import {api} from 'helpers/api';
import {success, error} from 'helpers/response';

export const getObjects = (meta = {}, cancelConditions) => async (dispatch) => {
    try {
        const response = await api.garbage.getObjects(meta, cancelConditions);

        return success(response);
    }
    catch (e) {
        return error(e);
    }
};

export const getLayers = (meta = {"items":[window.RNIS_SETTINGS.LAYERS_UUID]}) => async (dispatch) => {
    try {
        const response = await api.geo.listUserGeoObjectsByLayers(meta);

        return success(response);
    }
    catch (e) {
        return error(e);
    }
};



// WEBPACK FOOTER //
// ./src/store/reducers/garbage/objects.js